import "./AvailabilityToggle.css";

import {
  MdToggleOn,
  MdToggleOff,
} from "react-icons/md";

function AvailabilityToggle({
  isAvailable,
  onToggle,
  disabled = false,
}) {
  return (
    <button
      className={`availability-toggle ${
        isAvailable ? "available" : "unavailable"
      }`}
      onClick={onToggle}
      disabled={disabled}
      title={
        isAvailable
          ? "Mark as Unavailable"
          : "Mark as Available"
      }
    >
      {isAvailable ? (
        <>
          <MdToggleOn />
          <span>Available</span>
        </>
      ) : (
        <>
          <MdToggleOff />
          <span>Unavailable</span>
        </>
      )}
    </button>
  );
}

export default AvailabilityToggle;